import urls from '../api_urls/compare'
import { _post } from '@/axios/request'

// product > functionList
export function productFunction (params) {
  return _post(urls.productFunction, params)
}
// 添加对比列表
export function addCompare (params) {
  return _post(urls.ADD_COMPARE, params)
}
export function deleteCompare (params) {
  return _post(urls.DELETE_COMPARE, params)
}
export function brand (params) {
  return _post(urls.brandList, params)
}
export function brandMarket (params) {
  return _post(urls.brandMarket, params)
}
export function INCI (params) {
  return _post(urls.INCIList, params)
}
export function formulation (params) {
  return _post(urls.formulationList, params)
}
export function productINCI (params) {
  return _post(urls.productINCI, params)
}
export function productDetail (params) {
  return _post(urls.productDetail, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/compare.js